import React from 'react';
import lotusIcon from '../assets/lotus-icon.png';

export default function LotusIcon({ className = 'w-10 h-10' }) {
  return (
    <img
      src={lotusIcon}
      alt=""
      aria-hidden="true"
      className={className + ' object-contain'}
      draggable="false"
    />
  );
}
